import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const LOGOUT_PATH = '/logout';

export const LogoutLoadable = loadable(async () => import('./logout.view'), {
  fallback: <FullPageLoading />,
});
